import { render } from "./ClientServicesList.vue?vue&type=template&id=35d9d842&scoped=true"
import script from "./ClientServicesList.vue?vue&type=script&lang=js"
export * from "./ClientServicesList.vue?vue&type=script&lang=js"

import "./ClientServicesList.vue?vue&type=style&index=0&id=35d9d842&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35d9d842"]])

export default __exports__